import React from 'react';
import { parseEmailBody, type EmailBodyInlineNode } from '../../email/formatEmailBody';

export interface EmailMessageBodyProps {
  text: string;
  attachmentNames?: string[];
}

function renderInlineNodes(nodes: EmailBodyInlineNode[], keyPrefix: string): React.ReactNode[] {
  return nodes.map((node, index) => {
    const key = `${keyPrefix}-${index}`;
    if (node.type === 'text') {
      return node.value ? <React.Fragment key={key}>{node.value}</React.Fragment> : null;
    }
    if (node.type === 'link') {
      return (
        <a key={key} href={node.href} className="em-body-link" target="_blank" rel="noopener noreferrer">
          {node.label}
        </a>
      );
    }
    if (node.type === 'strong') {
      return (
        <strong key={key} className="em-body-strong">
          {renderInlineNodes(node.children, `${key}-s`)}
        </strong>
      );
    }
    if (node.type === 'em') {
      return (
        <em key={key} className="em-body-em">
          {renderInlineNodes(node.children, `${key}-e`)}
        </em>
      );
    }
    return (
      <span key={key} className="em-body-image-ref">
        [image: {node.name}]
      </span>
    );
  });
}

export function EmailMessageBody({ text, attachmentNames }: EmailMessageBodyProps) {
  const blocks = parseEmailBody(text, attachmentNames?.length ? { attachmentNames } : undefined);

  if (!blocks.length) return null;

  return (
    <div className="em-body-rich">
      {blocks.map((block, blockIndex) => {
        if (block.type === 'quote-header') {
          return (
            <div key={`qh-${blockIndex}`} className="em-body-quote-hd">
              {block.text}
            </div>
          );
        }

        const className = block.type === 'quote' ? 'em-body-quote' : 'em-body-paragraph';
        return (
          <div key={`b-${blockIndex}`} className={className}>
            {block.lines.map((line, lineIndex) => (
              <p key={`l-${lineIndex}`} className="em-body-line">
                {renderInlineNodes(line, `b-${blockIndex}-l-${lineIndex}`)}
              </p>
            ))}
          </div>
        );
      })}
    </div>
  );
}
